import { z } from "zod"

const requiredStringSchema = z.string().trim().min(1)

const commonClientEnvSchema = z.object({
  // Default Vite environment variables
  BASE_URL: z.string(),
  DEV: z.boolean(),
  MODE: z.enum(["development", "production", "test"]),
  PROD: z.boolean(),
  SSR: z.boolean(),

  // Kitchen-web environment variables shared by both providers
  VITE_AWS_REGION: requiredStringSchema,
  VITE_CONVEX_URL: z.url().optional(),
  VITE_KITCHEN_APP_ADMIN_SECRET: z.string().default(""),
  VITE_LOCIZE_API_KEY: requiredStringSchema,
  VITE_LOCIZE_PROJECT_ID: requiredStringSchema,
  VITE_LOCIZE_PROJECT_VERSION: requiredStringSchema,
  VITE_PUBLIC_POSTHOG_PROJECT_TOKEN: requiredStringSchema,
  VITE_PUBLIC_POSTHOG_HOST: z.url(),
})

const maulClientEnvSchema = commonClientEnvSchema.extend({
  VITE_FOOD_SERVICE_PROVIDER: z.literal("maul"),
  VITE_AWS_MAUL_USER_POOL_ID: requiredStringSchema,
  VITE_AWS_MAUL_USER_POOL_WEB_CLIENT_ID: requiredStringSchema,
  VITE_AWS_TIFFIN_USER_POOL_ID: z.string(),
  VITE_AWS_TIFFIN_USER_POOL_WEB_CLIENT_ID: z.string(),
})

const tiffinClientEnvSchema = commonClientEnvSchema.extend({
  VITE_FOOD_SERVICE_PROVIDER: z.literal("tiffin"),
  VITE_AWS_MAUL_USER_POOL_ID: z.string(),
  VITE_AWS_MAUL_USER_POOL_WEB_CLIENT_ID: z.string(),
  VITE_AWS_TIFFIN_USER_POOL_ID: requiredStringSchema,
  VITE_AWS_TIFFIN_USER_POOL_WEB_CLIENT_ID: requiredStringSchema,
})

export const clientEnvSchema = z.discriminatedUnion("VITE_FOOD_SERVICE_PROVIDER", [
  maulClientEnvSchema,
  tiffinClientEnvSchema,
])

export type TClientEnvInput = z.input<typeof clientEnvSchema>
export type TClientEnv = z.output<typeof clientEnvSchema>
